// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_m2K","cls2":"UserTaggingPingBodyStyles-cls2_oEy UserTaggingPingBodyStyles-cls1_m2K"};